export default theme => ({
  textField: {
    width: "100%"
  }
});
